module.exports = "/_next/static/resources/photo-3-ad697cb2d879a26abadd1710c441c148.jpg";